import React from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import WebLayout from "../components/WebLayout";
import PostList from "../components/PostList";

const GET_ESSAYS = gql`
  query GetEssays {
    articles(category: ESSAY) {
      id
      title
      source
      picture {
        filename
        mimetype
        encoding
        location
      }
      description
      content
      createdAt
    }
  }
`;

export default function Essay() {
  const { data } = useQuery(GET_ESSAYS);
  return (
    <WebLayout>
      {data && <PostList data={data.articles} />}
    </WebLayout>
  );
}
